import {
    CHANGE_SCREEN,
    CLOSE_PARKING_LOT_POPUP,
    CLOSE_SCREENS,
    OPEN_PARKING_LOT_POPUP,
    OPEN_SCREENS,
} from '../actions/types';

//  dirty way of handling cases where the values have not been set yet; associated with try-catches
const intialState = {
    activeScreen: 0,
    brightnessValue: 'brightness(100%)',
}

export default function (state = intialState, action) {
    switch (action.type) {
        case CHANGE_SCREEN:
            return {
                activeScreen: action.screenToDisplay,
                brightnessValue: 'brightness(50%)',
            };
        case OPEN_SCREENS:
            return {
                screensVisible: true,
                brightnessValue: 'brightness(50%)',
            };
        case CLOSE_SCREENS:
            return {
                screensVisible: false,
                brightnessValue: 'brightness(100%)',
            };

        case OPEN_PARKING_LOT_POPUP:
            return {
                parkingLotPopupVisible: true,
                brightnessValue: 'brightness(50%)',
            };

        case CLOSE_PARKING_LOT_POPUP:
            return {
                parkingLotPopupVisible: false,
                brightnessValue: 'brightness(100%)',
            };
        default:
            {
            return state;
            }
    }
}